/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import SamskritiCardColumn from '@components/Card/SamskritiCardColumn';
import SectionUI from '@components/UI/Common/SectionUI';
/* Styles */
/* Services */

/**
 * Renders Program Offered Component
 * @param {Object} sectionContent - Data of Section from api
 * @param {string} region - Region of the Section
 * @param {string} lang - Language of the Section
 * @returns {ReactElement} - Program Offered
 */
const ProgramOffered = ({ sectionContent, lang, region }) => {
  return (
    <Box pb="40px" pt="70px" maxW={'1170px'} m="0 auto" minW={'1px'}>
      {sectionContent && sectionContent.length
        ? sectionContent.map(section => {
            if (section._modelApiKey === 'card_samskriti3_column_group') {
              return (
                <SamskritiCardColumn
                  section={section}
                  region={region}
                  lang={lang}
                  key={nanoid(5)}
                />
              );
            } else {
              return (
                <SectionUI
                  key={nanoid(4)}
                  sectionContent={section}
                  region={region}
                  language={lang}
                />
              );
            }
          })
        : null}
    </Box>
  );
};

export default ProgramOffered;
